<template>
  <div class="lv2-categories-tags" v-show="hasLv2">
    <div name="tag-list" class="tag-list" v-show="isShowTagList">
      <v-checkbox v-model="showAllCheckbox" @change="toggle_show_all" label="显示全部" color="#106951"></v-checkbox>
      <v-btn rounded outlined depressed color="#fff" height="24" v-for="(item, index) in lv2_categories" :key="index" :data-lv2id="item.fileId" @click.self="on_goto_lv2_cate_page($event, index, item.fileId)">{{ item.name }}</v-btn>
    </div>
    <div class="tag-btn-box">
      <v-btn text flex x-large :ripple="false" class="tag-toggle show-more" ref="tag-toggle-btn" @click="isShowTagList = !isShowTagList">
        <v-icon>mdi-chevron-{{isShowTagList ? 'up' : 'down' }}</v-icon><span>{{isShowTagList ? '收起' : '查看二级标签' }}</span>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: "lv2-categories-tags",
  props: {
    lv1_categories: {
      type: Array,
      required: true,
    },
    lv2_categories: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      active: null,
      isShowTagList: false,
      showAllCheckbox: false,
      hasLv2: 1,
    };
  },
  computed: {
    ...mapState("global", [
      "allCardList",
      "allCardListMeta",
      "keyword",
      "driveIdsID",
      "lv1_ID",
      "lv2_ID",
      "formatType",
      "sequenceType",
      "starTime",
      "endTime",
    ]),
  },
  watch: {
    $route() {
      this.show_Lv2_box();
    },
  },
  mounted() {
    this.show_Lv2_box();
  },
  methods: {
    ...mapMutations("global", [
      "updateDriveIdsID",
      "updateLv1_ID",
      "updateLv2_ID",
      "updateFormatType",
      "updateSequenceType",
      "updateAllCardList",
      "updateAllCardListMeta",
      "updateChangeLv1ActiveItem",
    ]),

    toggle_show_all(value) {
      if (value) {
        $(".tag-list .v-btn").css("display", "inline-block");
      } else {
        $(".tag-list .v-btn").css("display", "none");
      }
    },
    on_goto_lv2_cate_page(event, index, fileId) {
      // if (this.active === index) return;

      $(".tag-list button").removeClass("active");
      event.target.classList.add("active");
      this.updateAllCardList("");
      this.handle_menus_interactive(event, fileId);
      this.GLOBAL.scrollPage = 1;
      this.$emit("get_list_data");
    },
    // 处理一二级菜单交互
    handle_menus_interactive(event, fileId) {
      this.GLOBAL.activeLv2Id = [fileId];

      // 获取当前选中的一级ID
      // let lv1CurrentId = $(".tags-list .v-btn--active").data("fileid");
      let lv1CurrentId = this.$route.params.materialList;
      $(`.tags-list button`).removeClass("include-lv2");
      let currentLv2Name = $(event.currentTarget).text();
      // 获取包含当前二级的一级菜单
      let lv1IncludeLv2Name = this.lv1_categories.filter((lvl1Item) => {
        return lvl1Item.lv2names.includes(currentLv2Name);
      });

      let lv1Id = lv1IncludeLv2Name.map((item) => {
        return item.fileId;
      });

      // 判断二级是否高亮（包含二级的一级id里是否有当前选中的一级ID）
      if (
        lv1Id.includes(lv1CurrentId) &&
        $(".tags-list .v-btn--active").length
      ) {
        // 如果已高亮，包含二级的其他一级不高亮，传入一级和二级ID
        this.updateDriveIdsID([this.$route.params.categories]);
      } else {
        for (let item of lv1Id.values()) {
          // 如果未高亮，给包含当前二级的一级加高亮
          $(`.tags-list button[data-fileid="${item}"]`).addClass("include-lv2");
        }

        $(`.tag-list button`).removeClass("lv1-children");
        setTimeout(() => {
          event.target.classList.add("lv1-children");
        }, 120);

        // 并取消一级菜单的选中状态
        $(`.tags-list button`).removeClass(
          "v-btn--active white--text v-slide-item--active"
        );
        // 还是不行，
        this.updateChangeLv1ActiveItem(0);

        this.updateLv1_ID([]);
      }
    },
    show_Lv2_box() {
      //  当前分类如果有二级标签，就显示展开收起标签功能，否则隐藏
      setTimeout(() => {
        this.hasLv2 = $(".tag-list button.lv1-children").length ? 1 : 0;
      }, 400);
    },
  },
};
</script>

<style lang="scss">
.lv2-categories-tags {
  width: 100%;
  margin-bottom: 8px;
  .tag-list {
    padding: 12px 16px 6px;
    background: rgba(255, 255, 255, 0.78);
    border: 1px solid #dff0ec;
    border-radius: 14px;
    margin-bottom: 6px;

    .v-btn {
      padding: 0 12px;
      margin-right: 8px;
      margin-bottom: 8px;
      height: 28px !important;
      border-color: $color-submenu-border-a;
      display: none;
      transition: all 0.2s ease;
      span {
        pointer-events: none;
        color: $color-normal;
        font-weight: 500;
      }
      &:hover {
        border-color: $color-emerald;
        background-color: $color-mint-light !important;
      }
      &.active {
        background: $gradient-brand-button !important;
        border-color: transparent !important;
        box-shadow: 0 4px 10px -2px rgba(16, 185, 129, 0.35);
        span {
          color: $color-white !important;
          font-weight: 600;
        }
      }
      &.lv1-children {
        display: inline-block !important;
        background-color: $color-mint-light !important;
        border-color: rgba(16, 185, 129, 0.45);
        span {
          color: $color-bright;
        }
      }
    }
    .v-input--checkbox {
      display: inline-block;
      margin-right: 28px;
      margin-top: 0;
    }
  }
  .tag-btn-box {
    text-align: center;
    margin: 4px 0 10px;
  }
  .tag-toggle {
    height: 34px !important;
    min-height: 34px !important;
    padding: 0 18px !important;
    border-radius: 999px !important;
    background: #ffffff !important;
    border: 1px solid #cde6df !important;
    box-shadow: 0 2px 8px rgba(13, 148, 136, 0.08);
    transition: all 0.2s ease;

    &:hover {
      background: $color-mint-light !important;
      border-color: $color-emerald !important;
      box-shadow: 0 4px 12px rgba(16, 185, 129, 0.16);
    }

    .v-btn__content {
      display: inline-flex !important;
      flex-direction: row !important;
      align-items: center !important;
      justify-content: center;
      gap: 4px;
      color: $color-bright;
      font-weight: 600;
      line-height: 1.4;
      margin: 0 auto;
      .v-icon {
        font-size: 18px !important;
        color: $color-emerald !important;
      }
      span {
        font-size: 13px;
        line-height: 1.4;
      }
    }
  }

  .tag-list-enter-active,
  .tag-list-leave-active {
    transition: all 0.35s ease;
  }
  .tag-list-enter,
  .tag-list-leave-active {
    transform: translate3d(0, 2rem, 0);
    opacity: 0;
  }
}
</style>
